import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Dialog from './dialog/Dialog'
import styles from './ConfirmModalV2.module.scss'
import { Button } from '@material-ui/core'
import { KEY_CODES } from '../kiosk/utils/constants'
import { ReactComponent as CloseIcon } from '../assets/icons/Close-Icon.svg'

//TODO (JEFF) document the params and use cases for this component

const ConfirmModalV2 = ({
  classNames,
  headerText,
  icon,
  subtext,
  extraSubtext,
  buttonOneText,
  buttonTwoText,
  onButtonOneClick,
  onButtonTwoClick,
  singleButtonOnly,
  emptyButtonContainer,
  isKiosk,
  inputRef,
  useInput,
  initialInputValue,
  displayCloseButton,
  onCloseButtonClick,
  opaque,
  alwaysEnableButtons = false,
}) => {
  const dialogClassNames = {
    dialog: cn(styles.confirmModalV2, classNames?.confirmModalV2),
    dialogContainer: classNames?.dialogContainer,
  }
  const singleButtonStyle = singleButtonOnly ? { width: '100%' } : {}
  const [inputValue, setInputValue] = useState(initialInputValue || '')
  const [buttonsDisabled, setButtonsDisabled] = useState(false)

  const handleKeyPress = (e) => {
    if (buttonsDisabled) return
    if (inputValue && e.keyCode === KEY_CODES.ENTER) {
      setButtonsDisabled(true)
      onButtonTwoClick(inputValue)
    }
  }

  return (
    <Dialog classNames={dialogClassNames} isKiosk={isKiosk} opaque={opaque}>
      <div className={cn(isKiosk ? styles.kioskContainer : styles.container, classNames?.container)}>
        {displayCloseButton && (
          <div className={styles.closeIcon} onClick={() => onCloseButtonClick(inputValue)}>
            <CloseIcon />
          </div>
        )}
        {isKiosk ? (
          <div className={cn(styles.textBox, classNames?.textBox)}>
            {icon && <div className={styles.icon}>{icon}</div>}
            <h1 className={styles.headerText}>{headerText}</h1>
            {subtext && <span className={styles.subtext}>{subtext}</span>}
          </div>
        ) : (
          <div className={cn(styles.textBox, classNames?.textBox)}>
            {icon && <div className={styles.icon}>{icon}</div>}
            {headerText && <div className={cn(styles.headerText, classNames?.headerText)}>{headerText}</div>}
            {subtext && <div className={subtext?.length < 100 ? styles.subtext : styles.smallSubtext}>{subtext}</div>}
            {extraSubtext && <div className={styles.extraSubtext}>{extraSubtext}</div>}
            {useInput && (
              <div className={subtext && styles.addMargin}>
                <input
                  ref={inputRef}
                  type="text"
                  id="confirmModalV2Input"
                  value={inputValue}
                  onChange={(e) => setInputValue(e?.target?.value)}
                  onKeyDown={handleKeyPress}
                  autoFocus
                />
              </div>
            )}
          </div>
        )}
        {!emptyButtonContainer && (
          <div className={styles.buttonContainer}>
            {!singleButtonOnly && (
              <Button
                className={isKiosk ? styles.button2 : styles.button}
                onClick={() => {
                  if (!alwaysEnableButtons) setButtonsDisabled(true)
                  onButtonOneClick(inputValue)
                }}
                disabled={buttonsDisabled}
              >
                {buttonOneText}
              </Button>
            )}
            <Button
              className={isKiosk ? styles.button2 : styles.button}
              onClick={() => {
                if (!alwaysEnableButtons) setButtonsDisabled(true)
                onButtonTwoClick(inputValue)
              }}
              style={singleButtonStyle}
              disabled={(useInput && !inputValue) || buttonsDisabled}
            >
              {buttonTwoText}
            </Button>
          </div>
        )}
      </div>
    </Dialog>
  )
}

ConfirmModalV2.defaultProps = {
  buttonOneText: 'CANCEL',
  buttonTwoText: 'CONFIRM',
  headerText: 'Confirm before proceeding',
  isKiosk: false,
  onButtonOneClick: () => {},
  onButtonTwoClick: () => {},
  singleButtonOnly: false,
  emptyButtonContainer: false,
  subtext: '',
  onCloseButtonClick: () => {},
  displayCloseButton: false,
  opaque: false,
}

ConfirmModalV2.propTypes = {
  buttonOneText: PropTypes.string,
  buttonTwoText: PropTypes.string,
  isKiosk: PropTypes.bool,
  onButtonOneClick: PropTypes.func,
  onButtonTwoClick: PropTypes.func,
  singleButtonOnly: PropTypes.bool,
  emptyButtonContainer: PropTypes.bool,
  onCloseButtonClick: PropTypes.func,
  opaque: PropTypes.bool,
}

export default ConfirmModalV2
